exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation-area[data-v-656fb959]{padding:0 40px}@media (max-width: 767px){.navigation-area[data-v-656fb959]{padding:0 8px}}@media (min-width: 1920px){.related-section[data-v-656fb959]{max-width:1650px}}.heading[data-v-656fb959]{color:#333C39;margin-top:25px;font-size:40px;font-weight:500;text-align:center}@media (max-width: 767px){.heading[data-v-656fb959]{font-size:28px}}\n", ""]);

// exports
